import TalkList from './speaker/talk-list.vue';
import TalkDetail from './speaker/talk-detail.vue';
import TalkDetailPage from './speaker/talk-detail-page.vue';
import SpeakerList from './speaker/speaker-list.vue';
import SpeakerDetail from './speaker/speaker-detail.vue';
import SpeakerThumb from './speaker/speaker-thumb.vue';
import SpeakerCard from './speaker/speaker-card.vue';
import SponsorList from './exhibitor/sponsor-list.vue';
import ExhibitorList from './exhibitor/exhibitor-list.vue';
import ExhibitorDetail from './exhibitor/exhibitor-detail.vue';
import ProductIndex from './exhibitor/product-index.vue';
import ChannelActivity from './channel/channel-activity.vue'
import ChannelPrivate from './channel/channel-private.vue'
import CommunityList from './speaker/community-list.vue'
import ContactList from './speaker/contact-list.vue'
import ContactDetail from './speaker/contact-detail.vue'

import {FavoriteStorage} from './speaker/storage.js';

// remember to build speaker-bundle and to disable cache for local dev
Vue.component('talk-list', TalkList)
Vue.component('talk-detail', TalkDetail)
Vue.component('talk-detail-page', TalkDetailPage)
Vue.component('speaker-list', SpeakerList)
Vue.component('speaker-detail', SpeakerDetail)
Vue.component('speaker-thumb', SpeakerThumb)
Vue.component('speaker-card', SpeakerCard)


Vue.component('exhibitor-list', ExhibitorList)
Vue.component('sponsor-list', SponsorList)
Vue.component('exhibitor-detail', ExhibitorDetail)
Vue.component('product-index', ProductIndex)

Vue.component('channel-activity', ChannelActivity)
Vue.component('channel-private', ChannelPrivate)

Vue.component('community-list', CommunityList)
Vue.component('contact-list', ContactList)
Vue.component('contact-detail', ContactDetail)

window.FavoriteStorage = FavoriteStorage